import ReleaseImageCard from './ReleaseImageCard';

export default ReleaseImageCard;
